<template lang="pug">
modal#show-unable-envelope-further-actions-modal(
  :process-button-label='$t("modal.unableEnvelopeFurtherActions.button")'
  :show-cancel-button='false'
  :title='$t("modal.unableEnvelopeFurtherActions.title", { status: translatedStatus })'
  @process='closeModal'
  ref='modal'
)
  .text {{ $t('modal.unableEnvelopeFurtherActions.message', { status: translatedStatus }) }}
  .text {{ $t('modal.unableEnvelopeFurtherActions.message2') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/application-warning.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'ShowUnableEnvelopeFurtherActionsModal',
  components: {
    Modal,
  },
  props: {
    envelopeStatus: {
      type: String,
      default: '',
    },
  },
  computed: {
    translatedStatus() {
      const envelopeStatus =
        this.$t(`signaturesList.envelopeStates.${this.envelopeStatus}`) ||
        this.envelopeStatus;
      return envelopeStatus.toLowerCase();
    },
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
